import { ArrangementType, CaliperMode, Format, GuidedComparisonType, PaperRate, TimeAlignment } from '../models/emuns';
import { CaliperMessage, CustomCommandState, EcgState } from './ecgstate';

export const FULL_STATE: string = 'FULL_STATE';

export const TOOLBAR_VISIBLE: string = 'TOOLBAR_VISIBLE';

export const ARRANGEMENT: string = 'ARRANGEMENT';
export const FORMAT: string = 'FORMAT';
export const TIME_ALIGNMENT: string = 'TIME_ALIGNMENT';
export const PAPER_RATE: string = 'PAPER_RATE';
export const PAPER_OPACITY: string = 'PAPER_OPACITY';
export const BASELINE: string = 'BASELINE';
export const TRACE_SPACING: string = 'TRACE_SPACING';
export const STUDY_SPACING: string = 'STUDY_SPACING';
export const HORIZONTAL_STUDY_SPACING: string = 'HORIZONTAL_STUDY_SPACING';
export const FIT: string = 'FIT';
export const ZOOM_FACTOR: string = 'ZOOM_FACTOR';
export const CALIPER_MODE: string = 'CALIPER_MODE';
export const FIDUCIAL_POINTS_VISIBLE: string = 'FIDUCIAL_POINTS';
export const PRINT_AS_DISPLAYED: string = 'PRINT_AS_DISPLAYED';
export const CULTURE: string = 'CULTURE';
export const DETAILS_VISIBLE: string = 'DETAILS_VISIBLE';
export const SUMMARY_VISIBLE: string = 'SUMMARY_VISIBLE';
export const CUSTOM_COMMAND: string = 'CUSTOM_COMMAND';
export const VISUAL_COMPARISON: string = 'VISUAL_COMPARISON';
export const GUIDED_COMPARISON: string = 'GUIDED_COMPARISON';

export const CALIPER_ADD: string = 'CALIPER_ADD';
export const CALIPER_REMOVE: string = 'CALIPER_REMOVE';
export const CALIPER_MODIFY: string = 'CALIPER_MODIFY';
export const MEASURELIST_CHANGED: string = 'MEASURELIST_CHANGED';

export interface GuidedComparisonMessageParam {
    traceSpacing: number;
    studySpacing: number;
    horizontalStudySpacing: number;
    guidedComparison: GuidedComparisonType;
}

export class MessageActions {
    private static commonMessage(action: { type: string; payload?: any }) {
        return Object.assign({}, action, { bypassIfEqual: true });
    }

    static toolBarVisibleMessage(visible: boolean) {
        return MessageActions.commonMessage({
            type: TOOLBAR_VISIBLE,
            payload: visible,
        });
    }

    static arrangementMessage(arrangement: ArrangementType) {
        return MessageActions.commonMessage({
            type: ARRANGEMENT,
            payload: arrangement,
        });
    }

    static formatMessage(format: Format) {
        return MessageActions.commonMessage({
            type: FORMAT,
            payload: format,
        });
    }

    static timeAligmentMessage(timeAlignment: TimeAlignment) {
        return MessageActions.commonMessage({
            type: TIME_ALIGNMENT,
            payload: timeAlignment,
        });
    }

    static paperRateMessage(paperRate: PaperRate) {
        return MessageActions.commonMessage({
            type: PAPER_RATE,
            payload: paperRate,
        });
    }

    static paperOpacityMessage(paperOpacity: number) {
        return MessageActions.commonMessage({
            type: PAPER_OPACITY,
            payload: paperOpacity,
        });
    }

    static isFitBaselineMessage(isFitBaseline: boolean) {
        return MessageActions.commonMessage({
            type: BASELINE,
            payload: isFitBaseline,
        });
    }

    static traceSpacingMessage(traceSpacing: number) {
        return MessageActions.commonMessage({
            type: TRACE_SPACING,
            payload: traceSpacing,
        });
    }

    static studySpacingMessage(studySpacing: number) {
        return MessageActions.commonMessage({
            type: STUDY_SPACING,
            payload: studySpacing,
        });
    }

    static horizontalStudySpacingMessage(horizontalStudySpacing: number) {
        return MessageActions.commonMessage({
            type: HORIZONTAL_STUDY_SPACING,
            payload: horizontalStudySpacing,
        });
    }

    static guidedComparisonMessage(guidedComparisonParam: GuidedComparisonMessageParam) {
        return MessageActions.commonMessage({
            type: GUIDED_COMPARISON,
            payload: guidedComparisonParam,
        });
    }

    static zoomFactorMessage(zoomFactor: number) {
        let message = MessageActions.commonMessage({
            type: ZOOM_FACTOR,
            payload: zoomFactor,
        });
        message.bypassIfEqual = false;
        return message;
    }

    static measureListChangedMessage() {
        let message = MessageActions.commonMessage({
            type: MEASURELIST_CHANGED,
        });
        message.bypassIfEqual = false;
        return message;
    }

    static fitMessage() {
        return Object.assign({}, { type: FIT }, { bypassIfEqual: false });
    }

    static caliperModeMessage(caliperMode: CaliperMode) {
        return MessageActions.commonMessage({
            type: CALIPER_MODE,
            payload: caliperMode,
        });
    }

    static fiducialPointsVisibleMessage(visible: boolean) {
        return MessageActions.commonMessage({
            type: FIDUCIAL_POINTS_VISIBLE,
            payload: visible,
        });
    }

    static printAsDisplayedMessage(value: boolean) {
        return MessageActions.commonMessage({
            type: PRINT_AS_DISPLAYED,
            payload: value,
        });
    }

    static cultureMessage(culture: number) {
        return MessageActions.commonMessage({
            type: CULTURE,
            payload: culture,
        });
    }

    static detailsVisibleMessage(visible: boolean) {
        return MessageActions.commonMessage({
            type: DETAILS_VISIBLE,
            payload: visible,
        });
    }

    static summaryVisibleMessage(visible: boolean) {
        return MessageActions.commonMessage({
            type: SUMMARY_VISIBLE,
            payload: visible,
        });
    }

    static customCommandMessage(customCommandState: CustomCommandState) {
        return MessageActions.commonMessage({
            type: CUSTOM_COMMAND,
            payload: customCommandState,
        });
    }

    static visualComparisonMessage(visualComparison: boolean) {
        return MessageActions.commonMessage({
            type: VISUAL_COMPARISON,
            payload: visualComparison,
        });
    }

    static fullStateMessage(ecgState: EcgState) {
        return MessageActions.commonMessage({
            type: SUMMARY_VISIBLE,
            payload: ecgState,
        });
    }

    static caliperAddMessage(caliperMessage: CaliperMessage) {
        return MessageActions.commonMessage({
            type: CALIPER_ADD,
            payload: caliperMessage,
        });
    }

    static caliperRemoveMessage(caliperMessage: CaliperMessage) {
        return MessageActions.commonMessage({
            type: CALIPER_REMOVE,
            payload: caliperMessage,
        });
    }

    static caliperModifyMessage(caliperMessage: CaliperMessage) {
        return MessageActions.commonMessage({
            type: CALIPER_MODIFY,
            payload: caliperMessage,
        });
    }
}
